import { InjectionToken } from '@angular/core';
import { Subject } from 'rxjs';

export const ADS_BANNER = new InjectionToken<any>('AdsIt');
export const ADS_PARAMS = new InjectionToken<Subject<any>>('AdsPP');
